import React from 'react'
import loadingGif from '../images/loading-2x-speed.gif'

export default function Loading(){
    return(
        <img src={loadingGif} al='' />
    )
}
